// src/store/index.js
import { create } from 'zustand';
import createTelegramSlice from './telegramSlice'; // Парсинг WebApp Init Data
import createSocketSlice from './socketProxySlice'; // Создание соединение, аутентификация

import createInfoSlice from './infoSlice'; // Загрузка игры, управление данными: игра, пользователь, группа, бот, кисти
import createMountSlice from './mountSlice'; // Подготовка данных, загрузка кешей 
import createWorkSlice from './workSlice'; // Эмиттеры игровых функций, сохранения настроек на сервере
import createMenuSlice from './menuSlice'; // Интерфейс-хелперы, функции вызова меню и всплывающих окон

// Связанное с холстом -- я отключил для Пазлов
import createConvySlice from './convySlice'; // Управление холстом, состояние курсора, клавиш
import createBrushSlice from './brushSlice'; // Состояние кистей, вспомогательные функции управления кистями и цветом
import createDrawingSlice from './drawingSlice'; // Вспомогательные функции рисования (расчет сложности, подготовка штрихов к отрисовке)
import createHistorySlice from './historySlice'; // Сохранение штрихов, отмена-восстановление штрихов, очистка холста 
import createPremiumSlice from './premiumSlice'; // Подготовка списка премиум-функций


import createDebugSlice from './debugSlice'; // Хранение логов и метрик для дебага

import createPuzzleSlice from '../components/canvaspuzzle/store/puzzleSlice'; // Игра ПАЗЛЫ
import createMafiaSlice from '../components/mafia/store/mafiaSlice'; // Игра МАФИЯ
import createAdSlice from './adSlice'; // Управление рекламой

import setupCanvasSizes from '../utils/drawing/canvasSetup'; // Определение верных размеров холста при запуске игры

const ref = { 
  methods: {},
  components: {},
  history: {},
 };

const useStore = create((set, get) => ({
  // Единый объект для не реактивных данных
  ref,
  // Подключаем слайсы, которые будут использовать общий объект ref
  setupCanvasSizes: () => setupCanvasSizes(),

  ...createTelegramSlice(set, get, ref),
  ...createSocketSlice(set, get, ref),

  ...createInfoSlice(set, get, ref),
  ...createPremiumSlice(set, get, ref),
  ...createWorkSlice(set, get, ref),
  ...createMenuSlice(set, get, ref),

  ...createConvySlice(set, get, ref),
  ...createBrushSlice(set, get, ref),
  ...createDrawingSlice(set, get, ref),
  ...createHistorySlice(set, get, ref),
  ...createMountSlice(set, get, ref),
  ...createDebugSlice(set, get, ref),
  ...createPuzzleSlice(set, get, ref),
  ...createMafiaSlice(set, get, ref), // Игра МАФИЯ
  ...createAdSlice(set, get, ref), // Управление рекламой
  // ...createGameSlice(set, get, ref),
}));

export default useStore;
